import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { OverlayContextProvider } from '@wix/da-react-context/pkg/OverlayContext';
import { BiData, SubmitButtonClickBiEvent } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import { URLS } from '@wix/da-url';
import OrderDropdown from '../../_partials/OrderDropdown';
import BasePageLayout from '../../_partials/BasePageLayout';
import DefaultPageContent from '../../_partials/DefaultPageContent';
import s from './BrowsePage.scss';

export interface Props {
  pageType?: string;
  feedType?: string;
  hasOrderSubnav?: boolean;
}

const BrowsePage: React.FC<Props> = ({
  pageType,
  hasOrderSubnav,
  feedType,
}) => {
  const { t } = useTranslation();
  const { isLoggedIn } = useContext(SessionContext);
  const isMobile = useContext(MobileContext);
  const rfyKillswitch = useFlag('homepage_rfy_killswitch');

  const isMobileHomePage = isMobile && pageType === 'home';
  const isShowingMobileSubmit =
    isMobileHomePage && isLoggedIn && feedType !== 'posts';
  // disable DD flag on anon and killswitched home page which is also a DD page
  const showDailyDeviationLabel =
    pageType !== 'home' || (isLoggedIn && !rfyKillswitch);

  return (
    <OverlayContextProvider
      value={{
        showDailyDeviationLabel,
      }}
    >
      <BasePageLayout
        title={
          isMobileHomePage
            ? undefined
            : t([`subnavigation.title.${pageType}`, 'subnavigation.title.home'])
        }
        headerRightSideContent={
          hasOrderSubnav && !isMobile && <OrderDropdown />
        }
      >
        {isMobile && hasOrderSubnav && (
          <div className={s['order-dropdown']}>
            <OrderDropdown />
          </div>
        )}

        {isShowingMobileSubmit && (
          <TextButton
            className={s['mobile-submit-button']}
            size="large"
            variant="main"
            href={URLS.SUBMIT}
            icon={AddIcon}
            biData={BiData<SubmitButtonClickBiEvent>({
              evid: 704,
              sectionname: 'general',
            })}
          >
            {t('browse.submitButton.mobile')}
          </TextButton>
        )}

        <DefaultPageContent />
      </BasePageLayout>
    </OverlayContextProvider>
  );
};
BrowsePage.displayName = 'BrowsePage';

export default BrowsePage;
